import styled from 'styled-components';

export const driverAllocationColors = {
  accepted: 'green',
  expired: 'gold',
  draft: 'gold',
  pending: 'gold',
  review: 'gold',
  cancelled: 'red',
  declined: 'red',
};

export const HeaderRow = styled.div`
  margin-bottom: 5px;
`;
